import { render } from "./NotificationSheet.vue?vue&type=template&id=5ba10318&scoped=true"
import script from "./NotificationSheet.vue?vue&type=script&lang=js"
export * from "./NotificationSheet.vue?vue&type=script&lang=js"

import "./NotificationSheet.vue?vue&type=style&index=0&id=5ba10318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba10318"]])

export default __exports__